// What anyone but the organization's Admin is told in place of a card action
// (#368 PO ruling, 2026-11-03), by what the Admin would do: replace the card on
// file, or add the first one.
export const ASK_ADMINISTRATOR = {
    update: "Ask your account administrator to update the payment method.",
    add: "Ask your account administrator to add a payment method.",
};
